import {useState} from 'react';
import {Tabs, TabsList, TabsTrigger, TabsContent} from '@/components/ui/tabs';
import TiersTab from './TiersTab';
import AffiliatesTab from './AffiliatesTab';
import OrdersTab from './OrdersTab';
import WithdrawalsTab from './WithdrawalsTab';

const AffiliateSystem = () => {
    const [tab, setTab] = useState('tiers');

    return (
        <div className="p-4 sm:p-6 lg:p-8">
            <h1 className="text-3xl font-bold mb-6">Affiliate System</h1>

            <Tabs value={tab} onValueChange={setTab} className="w-full">
                <div className="overflow-x-auto mb-6">
                <TabsList className="sm:grid sm:grid-cols-4 sm:max-w-2xl">
                    <TabsTrigger value="tiers" data-testid="affiliate-tab-tiers">Tier System</TabsTrigger>
                    <TabsTrigger value="affiliates" data-testid="affiliate-tab-affiliates">Foodk Affiliates</TabsTrigger>
                    <TabsTrigger value="orders" data-testid="affiliate-tab-orders">Orders</TabsTrigger>
                    <TabsTrigger value="withdrawals" data-testid="affiliate-tab-withdrawals">Withdrawal</TabsTrigger>
                </TabsList>
                </div>

                <TabsContent value="tiers"><TiersTab/></TabsContent>
                <TabsContent value="affiliates"><AffiliatesTab/></TabsContent>
                <TabsContent value="orders"><OrdersTab/></TabsContent>
                <TabsContent value="withdrawals"><WithdrawalsTab/></TabsContent>
            </Tabs>
        </div>
    );
};

export default AffiliateSystem;
